module.exports = __webpack_public_path__ + "static/media/sf-test-5.ebcf2070.mp3";